export class ACT_LOG_OPERATION {
    static INSERT: string = 'INSERT';
    static UPDATE: string = 'UPDATE';
    static DELETE: string = 'DELETE';
}

export class ACT_LOG_SOURCE {
    static REQUISITION_CANDIDATE: string = 'rstb_requisition_candidate';
    static REQUISITION_OFFER: string = 'rstb_requisition_offer';
    static INTERVIEW_DETAIL: string = 'rstb_interview_detail';
    static POSTING: string = 'cstb_posting';
    static PARTICIPANT: string = 'pstb_event_participant';
}

export class ACT_LOG_ACTION {
    static RECRUITMENT_MATCH_CANDIDATE_PROCESS: string = 'RECRUITMENT_MATCH_CANDIDATE_PROCESS';
    static RECRUITMENT_POSTING_JOB: string = 'RECRUITMENT_POSTING_JOB';
    static RECRUITMENT_ONLINE_CANDIDATE: string = 'RECRUITMENT_ONLINE_CANDIDATE';
    static RECRUITMENT_CANDIDATE_RR: string = 'RECRUITMENT_CANDIDATE_RR';
    static RECRUITMENT_STUDENT_PROGRAM: string = 'RECRUITMENT_STUDENT_PROGRAM';
}